export enum NotificationType {
  User = 'user',
  Group = 'group',
}
